import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Minnetonka, MN?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Minnetonka can take 2–6 months. For corporate travelers and families with international plans, that timeline is not viable.",
  },
  {
    q: "Can corporate travelers from UnitedHealth Group and Cargill expedite quickly?",
    a: "Absolutely. Corporate travelers are one of our most common client types in Minnetonka. International business trips often arrive with 2–3 weeks notice. We regularly process expedited renewals for professionals on compressed timelines — as fast as 2–9 business days.",
  },
  {
    q: "What if my passport expires before a Lake Minnetonka summer trip to Canada?",
    a: "Many Minnetonka residents maintain cabins and vacation properties in Canada. Canada travel requires current passports for all travelers, including children. If your passport is close to expiring, we recommend expedited processing. Standard mail-in renewal typically takes 2–6 months.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Minnetonka travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Minnetonka. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the western metro.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
  },
  {
    q: "What is the closest passport acceptance office to Minnetonka?",
    a: "The Minnetonka Post Office on County Road 101 accepts passport applications by appointment. Wayzata, Plymouth, and Eden Prairie post offices are nearby alternatives. For first-time applicants and minors who need an acceptance clerk visit, we provide clear instructions on which local facility is best for your situation.",
  },
  {
    q: "Can Wayzata and Excelsior residents use the same expedited service?",
    a: "Yes. Wayzata, Excelsior, and Chanhassen travelers have the same access to our expedited services as Minnetonka residents. Since we operate remotely, your physical location in Hennepin County does not affect processing speed. Ship your documents overnight from any UPS or FedEx location, and we handle the rest.",
  },
];

export default function MinnetonkaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Minnetonka and western metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}